import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayIncludes',
  standalone: true
})
export class ArrayIncludesPipe implements PipeTransform {

  public transform(arr: any[], search: any): boolean {
    return arr.includes(search);
  }
}
